<template>
  <van-popup
    v-model="visible"
    :style="{ height: '100%' }"
    position="bottom"
    @open="open"
  >
    <div class="popup-title">
      <van-icon class="icon" name="arrow-left" @click="hidePopup" />
      <span class="text">
        {{ productId ? '编辑半成品' : '新增半成品' }}
      </span>
      <span class="del">
        <span v-if="productId" style="color: #ff4444;font-size: 14px;" @click="handleDel">删除</span>
      </span>
    </div>
    <van-form
      ref="PackingPopup"
      class="packing-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div class="main">
        <van-field
          v-model="form.name"
          :rules="rules.name"
          label="产品名称"
          name="产品名称"
          placeholder="请输入产品名称"
        />
        <wh-popup-select
          v-model="form.raw"
          :columns="rawListSelect"
          class="raw-selete"
          label="原料"
          placeholder="请输入原料"
          @change="changeFn"
        />
        <div v-for="(i,key) in form.rawMaterialInfo||[]" :key="key">
          <div v-if="!i.deleted" class="raw-list wh-flex-between">
            <div class="material-name van-ellipsis">
              {{ i.materialName }}
            </div>
            <div>库存：{{ i.quantity }}</div>
            <div class="wh-flex-start count" style="width: 100px">
              <span>用量：</span>
              <van-field
                v-model.number="i.recordsQuantity"
                :disabled="i.flag"
                class="quantity"
                input-align="center"
                type="number"
              />
              <span>
                {{ i.materialUnit }}
              </span>
            </div>
            <div>
              <van-icon v-if="!i.flag" color="#20CAA0" name="checked" size="20" @click="subRaw(i)" />
              <svg-icon v-else icon-class="edit" style="width:20px;height:20px" @click.native="i.flag = !i.flag" />
              <van-icon v-if="!productId" color="#FF4444" name="delete" size="20" @click="delRaw(i,key)" />
            </div>
          </div>
        </div>
        <wh-popup-select
          v-model="form.process"
          :columns="processListSelect"
          :disabled="formType!=='create'"
          :rules="rules.process"
          label="加工过程"
          placeholder="请选择加工过程"
          @change="changeProcessFn"
        />
        <van-field :rules="rules.unit" :value="form.quantity" label="数量">
          <template #input>
            <div class="unit-box">
              <van-stepper
                v-model.number="form.quantity"
                :min="0"
                decimal-length="2"
                input-width="60px"
              />
              <wh-select-popup v-model="form.unit" :options="unitOptions" placeholder="单位" />
            </div>
          </template>
        </van-field>
        <wh-field-time-popup
          v-model="form.operatorTime"
          :rules="rules.operatorTime"
          input-align="left"
          label="操作时间"
          type="date"
        />
        <wh-staff v-model="form.operator" :rules="rules.operator" lable="操作人" />
      </div>
    </van-form>
    <div class="submit-box">
      <van-button block class="submit" type="info" @click="submitForm">
        确定
      </van-button>
    </div>
  </van-popup>
</template>

<script>
import { formPopup } from '@/utils/mixins/formPopup'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'
import WhSelectPopup from '@/components/public/WhSelectPopup/WhSelectPopup'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import WhStaff from '@/components/public/WhStaff/WhStaff'
import { packOptions, unitOptions } from '@/constant/common'
import api from '@/api'
import dayjs from 'dayjs'

export default {
  name: 'PopupProductOperation',
  components: { WhPopupSelect, WhSelectPopup, WhFieldTimePopup, WhStaff },
  mixins: [formPopup],
  props: {
    productId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    const unitValidator = (value, rule) => {
      return !!this.form.quantity && !!this.form.unit
    }
    return {
      unitOptions,
      packOptions,
      rules: {
        name: [{ required: true, message: '请输入产品名称' }],
        process: [{ required: true, message: '请选择加工过程', trigger: 'onChange' }],
        unit: [{ validator: unitValidator, message: '请选择完整的数量' }],
        operatorTime: [{ required: true, message: '请选择操作时间' }],
        operator: [{ required: true, message: '请选择操作人' }]
      },
      productName: undefined,
      form: {},
      rawListSelect: [],
      processList: [],
      processListSelect: [],
      rawList: []
    }
  },
  watch: {
    visible: {
      handler() {
        this.$nextTick(() => {
          this.$refs.PackingPopup.resetValidation()
        })
      }
    }
  },
  methods: {
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    getrawList() {
      this.rawList = []
      this.rawListSelect = []
      api.getRawMaterialsStockList().then(res => {
        this.rawList = res.data.list
        res.data.list.forEach(i => {
          if (i.quantity) {
            this.rawListSelect.push({
              text: `${i.materialName}  剩余:${i.quantity}`,
              value: i.id
            })
          }
        })
      })
    },
    getProcessList() {
      this.processList = []
      this.processListSelect = []
      api.getProcessing().then(res => {
        this.processList = res.data.list
        res.data.list.map(i => {
          this.processListSelect.push({
            text: i.craftName,
            value: i.id
          })
        })
      })
    },
    subRaw(i) {
      if (i.recordsQuantity > i.quantity) {
        this.$toast.fail('输入数量超过库存')
      } else {
        i.flag = true
      }
    },
    handleDel() {
      this.$dialog.confirm({
        title: '是否删除?'
      })
        .then(() => {
          api.deleteParPreparedProducts({ ids: [this.productId] }).then(() => {
            this.hidePopup()
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    delRaw(row, index) {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        if (row.id) {
          this.form.rawMaterialInfo.splice(index, 1)
          return
        }
        if (row.deleted === 0) {
          row.deleted = 1
        }
      }).catch(() => {
      })
    },
    changeFn(val) {
      this.rawList.map(item => {
        if (item.id === val && item.quantity) {
          this.form.rawMaterialInfo.push({
            ...item,
            rawMaterialsInventoryRecordsId: null,
            stockId: item.id,
            recordsQuantity: 0,
            lastrecordsQuantity: 0,
            flag: false,
            deleted: 0
          })
        }
      })
    },
    changeProcessFn(val) {
      this.processList.map(item => {
        if (item.id === val) {
          this.form.processJson = { ...item }
        }
      })
    },
    submitForm() {
      if (!this.form.rawMaterialInfo.length) {
        this.$toast.fail('原料未选择')
        return
      } else {
        if (this.form.rawMaterialInfo.some(i => {
          return !i.flag
        })) {
          this.$toast.fail('部分原料未确定')
          return
        }
      }
      const param = {
        ...this.form,
        operatorTime: dayjs(this.form.operatorTime).format('YYYY-MM-DD'),
        processMng: this.form.processJson.craftName
      }
      if (this.productId) {
        api.getParPreparedProduct({ name: this.form.name }).then(({ data }) => {
          if (data.name && data.name !== this.productName) {
            this.$toast.fail('已存在改名称的半成品')
          } else {
            api.updateParPreparedProducts(param).then(() => {
              this.$toast('编辑半成品成功')
              this.hidePopup()
            })
          }
        })
      } else {
        api.getParPreparedProduct({ name: this.form.name }).then(({ data }) => {
          if (!data.name) {
            api.createParPreparedProducts(param).then(res => {
              this.$toast('添加半成品成功')
              this.hidePopup()
            })
          } else {
            this.$toast.fail('已存在改名称的半成品')
          }
        })
      }
    },
    async open() {
      await this.getrawList()
      await this.getProcessList()
      if (this.productId) {
        api.getParPreparedProduct({ id: this.productId }).then(({ data }) => {
          this.form = {
            process: data.processJson.id,
            ...data, rawMaterialInfo: data.rawMaterialInfo.map(i => ({
              ...i,
              quantity: i.stockQuantity,
              flag: true
            }))
          }
          this.productName = data.name
        })
      } else {
        this.form = {
          name: '',
          operatorTime: '',
          processJson: {},
          rawMaterialInfo: [],
          quantity: undefined,
          unit: '袋',
          operator: ''
        }
      }
      this.$nextTick(() => {
        this.$refs.PackingPopup.resetValidation()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-title {
  margin-top: 16px;
  text-align: center;
  position: relative;
  .icon, .del {
    position: absolute;
    font-size: 18px;
    top: 4px;
  }
  .icon {
    left: 10px;
  }
  .del {
    right: 10px;
  }
  .text {
    font-weight: bold;
    letter-spacing: 0.1em;
    color: #333333;
    font-size: 20px;
  }
}
.submit-box {
  @height: 40px;
  height: @height; //用于占位
  display: block;
  width: 100%;
  .submit {
    height: @height;
    position: fixed;
    letter-spacing: 0.2em;
    bottom: 0;
    left: 0;
    padding: 20px 0 30px 0;
  }
}
.main {
  background-color: #fff;
  .raw-selete {
    /deep/ .van-field__control {
      display: none;
    }
  }
  .raw-list {
    padding: 5px 16px;
    margin-bottom: 2px;
    font-size: 12px;
    background-color: rgba(32, 202, 160, 0.12);
    word-break: keep-all;
    .material-name {
      width: 100px;
      &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #20CAA0;
        margin-right: 6px;
        margin-bottom: 2px;
      }
    }
    .quantity {
      width: 60px;
      font-size: 12px;
      padding: 0;
      background-color: #fff;
    }
  }
  .unit-box {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
